export const environment = {
    ENVIRONMENT: 'qa',
    CHATBOT_BASE_URL: 'https://qa-chatbot.nopalcyber.com',
    CHATBOT_BUILD_VERSION: '1.0.0',
    DOMAIN_PREFIX: 'qa-chatbot-app',
    DOMAIN: 'nopalcyber.com',
    CHATBOT_CLOUD_FRONT_URL :'https://d35sesrdyj5132.cloudfront.net'
};